(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  function loadHoverImage(card) {
    const image = card?.querySelector('[data-lk-product-hover]');
    if (!image || image.dataset.lkHoverState) return;

    image.dataset.lkHoverState = 'loading';
    const markReady = () => {
      image.dataset.lkHoverState = 'ready';
      image.classList.add('is-ready');
    };

    image.addEventListener('load', markReady, { once: true });
    image.addEventListener('error', () => {
      image.dataset.lkHoverState = 'error';
    }, { once: true });

    if (image.dataset.sizes) image.sizes = image.dataset.sizes;
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;

    delete image.dataset.sizes;
    delete image.dataset.srcset;
    delete image.dataset.src;

    if (image.complete && image.naturalWidth > 1) markReady();
  }

  function handleIntent(event) {
    loadHoverImage(event.target.closest('.pc'));
  }

  document.addEventListener('pointerover', handleIntent, { passive: true });
  document.addEventListener('focusin', handleIntent);
})();
